var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.itens,"empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","responsive":"sm","stacked":"md","show-empty":"","striped":""},on:{"sort-changed":_vm.aoMudarOrdenacao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }